import React, { useState } from 'react'
import styles from './DocumentView.module.scss'
import { addAttachment, deleteAttachment } from '../../../../service/DocflowService'

function fmtSize(bytes) {
  if (!bytes) return ''
  if (bytes < 1024) return `${bytes} Б`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} КБ`
  return `${(bytes / 1024 / 1024).toFixed(1)} МБ`
}

const FILE_ICONS = {
  pdf: '📕', doc: '📘', docx: '📘', xls: '📗', xlsx: '📗',
  ppt: '📙', pptx: '📙', jpg: '🖼️', jpeg: '🖼️', png: '🖼️',
  zip: '🗜️', rar: '🗜️', txt: '📃',
}

export default function AttachmentsList({ docId, attachments: init = [], isCreator }) {
  const [attachments, setAttachments] = useState(init)
  const [previewUrl, setPreviewUrl]   = useState(null)
  const [previewExt, setPreviewExt]   = useState('')
  const [uploading, setUploading]     = useState(false)

  async function handleUpload(e) {
    const file = e.target.files[0]
    if (!file) return
    const fd = new FormData()
    fd.append('file', file)
    setUploading(true)
    try {
      const r = await addAttachment(docId, fd)
      setAttachments(prev => [...prev, r.data])
    } finally { setUploading(false) }
  }

  async function handleDelete(id) {
    await deleteAttachment(id)
    setAttachments(prev => prev.filter(a => a.id !== id))
  }

  return (
    <div className={styles.attachmentsSection}>
      <h3 className={styles.panelSectionTitle}>
        Вложения
        {attachments.length > 0 && (
          <span className={styles.commentCount}>{attachments.length}</span>
        )}
      </h3>

      {attachments.length === 0 && <p className={styles.emptySub}>Вложений нет</p>}

      <div className={styles.attachList2}>
        {attachments.map(a => {
          const ext  = (a.file_extension || '').toLowerCase()
          const icon = FILE_ICONS[ext] || '📎'
          const canPreview = ['pdf', 'jpg', 'jpeg', 'png'].includes(ext)

          return (
            <div key={a.id} className={styles.attachItem2}>
              <span className={styles.attachIcon2}>{icon}</span>
              <div className={styles.attachInfo}>
                <span className={styles.attachName2}>{a.file_name}</span>
                <span className={styles.attachSize2}>{fmtSize(a.file_size)}</span>
              </div>
              <div className={styles.attachItemActions}>
                {canPreview && (
                  <button
                    className={styles.attachActionBtn}
                    title="Просмотр"
                    onClick={() => { setPreviewUrl(a.file_url); setPreviewExt(ext) }}
                  >
                    👁
                  </button>
                )}
                <a
                  className={styles.attachActionBtn}
                  href={a.file_url}
                  target="_blank"
                  rel="noreferrer"
                  title="Скачать"
                >
                  ⬇
                </a>
                {isCreator && (
                  <button
                    className={`${styles.attachActionBtn} ${styles.attachDeleteBtn}`}
                    onClick={() => handleDelete(a.id)}
                    title="Удалить"
                  >
                    ×
                  </button>
                )}
              </div>
            </div>
          )
        })}
      </div>

      {isCreator && (
        <label className={styles.addAttachBtn}>
          {uploading ? 'Загрузка…' : '+ Добавить вложение'}
          <input type="file" hidden disabled={uploading} onChange={handleUpload} />
        </label>
      )}

      {/* Preview modal */}
      {previewUrl && (
        <div className={styles.previewOverlay} onClick={() => setPreviewUrl(null)}>
          <div className={styles.previewBox} onClick={e => e.stopPropagation()}>
            <button className={styles.previewClose} onClick={() => setPreviewUrl(null)}>×</button>
            {previewExt === 'pdf' ? (
              <iframe src={previewUrl} className={styles.previewIframe} title="Preview" />
            ) : (
              <img src={previewUrl} alt="Preview" className={styles.previewImg} />
            )}
          </div>
        </div>
      )}
    </div>
  )
}
